import React, { useEffect } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import EditTableModal from "./EditTableModal";
import { useDispatch, useSelector } from "react-redux";

function LongTermFlowsTable(props: any) {
  const dispatch: any = useDispatch();
  const [page, setPage] = React.useState(0);
  const [rows, setRows] = React.useState([]);
  const [isProcessed, setIsProcessed] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [isOpenEditModal, setIsOpenEditModal] = React.useState(false);
  const [editedData, setEditedData] = React.useState({});
  const [updatedVal, setUpdatedVal] = React.useState<any>(editedData);
  const [resetValues, setResetValues] = React.useState({ landed_Cost: 0 });

  const selectedUsecaseId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId,
  );
  const selectedCategoryId = useSelector(
    (state: any) => state.InputDataReducers.selectedCategoryId,
  );

  /**Redux state */
  const selectedFolderId = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderId,
  );

  const selectedScenarioId = useSelector(
    (state: any) => state.InputDataReducers.selectedScenarioId,
  );

  const isEditEnabled = useSelector(
    (state: any) => state.InputDataReducers.editFilterEnable,
  );

  useEffect(() => {
    setIsProcessed(props.isProcessed);
    setRows(props.rowsData);
  }, [props.rowsData]);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleEditTableRow = (e: any, row: any) => {
    setResetValues({ landed_Cost: row?.landed_Cost });
    setIsOpenEditModal(true);
    setEditedData(row);
  };

  const handleChangeEditValue = (e: any) => {
    setUpdatedVal({
      ...editedData,
      ...updatedVal,
      [e.target.name]: e.target.value,
    });
  };

  const UpdateTableRow = () => {};

  const closeEditModal = () => {
    setIsOpenEditModal(false);
  };

  return (
    <>
      {isOpenEditModal && (
        <EditTableModal
          isOpen={isOpenEditModal}
          editedData={editedData}
          resetValues={resetValues}
          UpdateTableRow={UpdateTableRow}
          onClose={closeEditModal}
          handleChangeEditValue={handleChangeEditValue}
          headerName="LandCost Table"
        />
      )}
      <Paper sx={{ width: "100%", overflow: "hidden" }}>
        <TableContainer sx={{ maxHeight: 440 }}>
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                {props?.columns.map((column: any) => (
                  <TableCell
                    key={column.id}
                    align="left"
                    style={{
                      minWidth: column.minWidth,
                      fontWeight: column.fontWeight,
                    }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {!isProcessed ? (
                <TableRow>
                  <TableCell colSpan={8}>
                    <div className="nodata-display">Processing...</div>
                  </TableCell>
                </TableRow>
              ) : rows && rows.length > 0 ? (
                rows
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row: any, index: any) => {
                    return (
                      <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                        {props?.columns.map((column: any) => {
                          const value = row[column.id];
                          return (
                            <TableCell key={column.id} align="left">
                              {selectedScenarioId > 0 &&
                              column.label === "Volume"
                                ? ""
                                : column.format && typeof value === "number"
                                  ? column.format(value)
                                  : value}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })
              ) : (
                <TableRow>
                  <TableCell colSpan={8}>
                    <div className="nodata-display">No Data to Display.</div>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50, 100]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </>
  );
}

export default LongTermFlowsTable;
